import { useEffect, useState } from 'react';
import { isStaleChunkReloadSuppressed, reloadForStaleChunk } from '../lib/stale-chunk';
import { cn } from '../lib/utils';
import { STALE_BUNDLE_TITLE } from '../lib/app-version';
import { Button } from './ui/Button';
import { LoadingState } from './ui/LoadingState';

interface Props {
  className?: string;
}

/**
 * What an error boundary renders for a stale chunk: a deploy is not a fault, so
 * the user sees a short "Updating Bill…" while the page reloads onto it. Only when
 * this tab already reloaded moments ago (a loop) does it ask them to reload.
 */
export function StaleChunkRecovery({ className }: Props) {
  // Decided once, at the catch: a reload loop asks the user instead of reloading again.
  const [declined] = useState(isStaleChunkReloadSuppressed);

  useEffect(() => {
    if (!declined) reloadForStaleChunk();
  }, [declined]);

  if (!declined) return <LoadingState message="Updating Bill…" className={className} />;

  return (
    <div role="alert" className={cn('flex flex-col items-center justify-center gap-4 p-8 text-center', className)}>
      <div>
        <h2 className="text-lg font-semibold text-text-primary">{STALE_BUNDLE_TITLE}</h2>
        <p className="mt-1 text-sm text-text-muted">This page needs a reload to load the latest version.</p>
      </div>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
}
